import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { EXPIRY_REASONS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from '../models/ColumnDefinitions/ExpiryReasonColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/ExpiryReasonSearch';
import SiteSearch from "../models/search/SiteSearch";
import { getExpiryReasons } from "../services/expiryReasonService";
import { getSiteNamesWithPagination } from "../services/siteService";

const ExpiryReasonsTab: FC = () => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.expiryReasons);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/module/expiry-reason/';

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const initialiseUserPreferences = (setDetails: (userLoginId, EXPIRY_REASONS) => void) => {
        setDetails(userLoginId, EXPIRY_REASONS);
    }
    // <-- end context

    return <TableContextProvider
        dataMethod={getExpiryReasons}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useFilter
        useSearch
        useSort
        lookup={lookup}>
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath} 
            cyName="expiryReasons"/>
    </TableContextProvider>;
};

export default ExpiryReasonsTab;
